import mime from "mime-types";

export const newFile = (data, fileName, contentType) => {
  const blob = new Blob([data], { type: contentType });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.style = "display: none";
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
};

export const handleDownload = (response) => {
  const contentType = response.headers["content-type"];
  const contentDisposition = response.headers["content-disposition"];

  const extension = mime.extension(contentType) || "pdf";
  const name =
    contentDisposition
      .split("filename=")[1]
      .split(";")[0]
      .replace(/^"|"$/g, "") || `Report.${extension}`;

  newFile(response.data, name, contentType);
};
